import { NavLink } from 'react-router-dom'
import { Home, ScrollText, Timer, Flame, Shirt } from 'lucide-react'
import { motion } from 'framer-motion'

const navItems = [
  { path: '/', label: 'Home', Icon: Home },
  { path: '/quests', label: 'Quests', Icon: ScrollText },
  { path: '/pomodoro', label: 'Focus', Icon: Timer },
  { path: '/habits', label: 'Habits', Icon: Flame },
  { path: '/closet', label: 'Closet', Icon: Shirt },
]

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pt-2 bg-gradient-to-t from-bg-surface via-bg-surface to-transparent safe-bottom">
      <div className="flex justify-around items-center bg-bg-card rounded-2xl p-2 border border-white/5">
        {navItems.map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            className="relative"
          >
            {({ isActive }) => (
              <motion.div
                className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors ${
                  isActive
                    ? 'text-white'
                    : 'text-text-secondary hover:text-primary'
                }`}
                whileTap={{ scale: 0.95 }}
              >
                {isActive && (
                  <motion.div
                    layoutId="navIndicator"
                    className="absolute inset-0 bg-gradient-to-r from-primary to-secondary rounded-xl shadow-glow-pink"
                    initial={false}
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
                <Icon size={20} className="relative z-10" />
                <span className="text-[11px] font-semibold relative z-10">
                  {label}
                </span>
              </motion.div>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
